import React, { useEffect, useState } from 'react';
import axiosInstance from "../../../../axiosInstance";
import { API_URL } from "../../../../config";
import { Helmet } from 'react-helmet-async';

function EmpPackagesPage() {
    const [requests, setRequest] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchRequests = async () => {
            try {
                const res = await axiosInstance.get(`${API_URL}/admin/getAllRequest`);
                setRequest(res.data.data);
            } catch (err) {
                console.error("Failed to fetch requests", err);
            } finally {
                setLoading(false);
            }
        };

        fetchRequests();
    }, []);

    useEffect(() => {
        let dataTable = null;
        if (!loading && requests.length > 0) {
            const $ = window.$;
            // Destroy existing DataTable if it exists
            if ($.fn.DataTable.isDataTable('#requests_table')) {
                $('#requests_table').DataTable().destroy();
            }

            // Initialize new DataTable
            dataTable = $('#requests_table').DataTable({
                responsive: true,
                searching: true,
                ordering: true,
                paging: true,
                pageLength: 10,
                destroy: true,
                autoWidth: false,
                dom: 'Bfrtip',
                language: {
                    search: "Search:",
                    searchPlaceholder: "Search requests...",
                    emptyTable: "No requests available",
                    zeroRecords: "No matching requests found"
                },
                columnDefs: [
                    { 
                        targets: [7], // Resume column
                        orderable: false,
                        searchable: false
                    }
                ],
                order: [[0, 'desc']], // Sort by ID by default, newest first
                drawCallback: function() {
                    // Reinitialize tooltips after table draw
                    $('[data-bs-toggle="tooltip"]').tooltip();
                }
            });
        }

        // Cleanup function
        return () => {
            if (dataTable) {
                dataTable.destroy();
            }
        };
    }, [loading, requests]);

    return (
        <>
            <Helmet>
                <title>Requests | CV Diffusion</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>
            <div className="wt-admin-right-page-header clearfix">
                <h2>Request</h2>
                <div className="breadcrumbs"><a href="#">Home</a><a href="#">Dashboard</a><span>Requests</span></div>
            </div>
            <div className="panel panel-default site-bg-white m-t30">
                <div className="panel-heading wt-panel-heading p-a20">
                    <h4 className="panel-tittle m-a0"><i className="fa fa-suitcase" />Requests</h4>
                </div>
                <div className="panel-body wt-panel-body">
                    <div className="p-a20 table-responsive">
                        <table id="requests_table" className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Name</th>
                                    <th>Company Name</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Industry</th>
                                    <th>Job Title</th>
                                    <th>JC</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!loading && requests.map((request, idx) => (
                                    <tr key={idx}>
                                        <td>{request.id || 'N/A'}</td>
                                        <td>{request.name || 'N/A'}</td>
                                        <td>{request.company_name || 'N/A'}</td>
                                        <td>
                                            {request.emp_email ? (
                                                <a href={`mailto:${request.emp_email}`} className="text-primary">
                                                    {request.emp_email}
                                                </a>
                                            ) : 'N/A'}
                                        </td>
                                        <td>{request.emp_number || 'N/A'}</td>
                                        <td>{request.industry || 'N/A'}</td>
                                        <td>{request.job_title || 'N/A'}</td>
                                        <td>
                                            {request.emp_description_file ? (
                                                <a
                                                    href={`${API_URL.replace('/api', '')}/app/uploads/${request.emp_description_file}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-sm btn-primary"
                                                    data-bs-toggle="tooltip"
                                                    title="View Resume"
                                                >
                                                    <i className="far fa-file-alt me-1"></i> View
                                                </a>
                                            ) : (
                                                <span className="badge bg-secondary">No file</span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>Id</th>
                                    <th>Name</th>
                                    <th>Company Name</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Industry</th>
                                    <th>Job Title</th>
                                    <th>Resume</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EmpPackagesPage;